import MockProfilePhoto from "../images/_mocks_/avatars/avatar_default.jpg";

// ----------------------------------------------------------------------

const account = {
  displayName: "Jaydon Frankie",
  email: "demo@minimals.cc",
  photoURL: MockProfilePhoto,
};

export default account;
